module.exports = __webpack_public_path__ + "media/images/MarcaBranca-e310fb8ba837c614411a5a6dfd4cc5a6.png";